<div class="card flex justify-content-center">
       <p-card [header]="pageTitle"
               [style]="{ width: '360px' }"
               class="flex justify-content-center">

              <form [formGroup]="editUserForm">
                     <div>
                            <label for="userTypeItem"
                                   class="block text-900 font-medium mb-2">User Type</label>
                            <p-dropdown formControlName="userTypeItem"
                                        class="mb-2"
                                        [options]="userTypePDropdownItems"
                                        optionLabel="value"
                                        placeholder="Select User Type"></p-dropdown>

                            <label for="clientDropdownItem"
                                   class="block text-900 font-medium my-2">Client</label>
                            <p-dropdown class="block text-900 font-medium mb-2"
                                        formControlName="clientDropdownItem"
                                        [options]="clientDropdownItems"
                                        optionLabel="name"
                                        placeholder="Select Client"></p-dropdown>

                            <label for="first"
                                   class="block text-900 font-medium mb-2"> First Name</label>
                            <input id="first"
                                   formControlName="first"
                                   name="first"
                                   required
                                   type="text"
                                   placeholder="Enter First Name"
                                   class="p-inputtext p-component p-element w-full mb-3">

                            <label for="last"
                                   class="block text-900 font-medium mb-2"> Last Name</label>
                            <input id="last"
                                   formControlName="last"
                                   name="last"
                                   required
                                   type="text"
                                   placeholder="Enter Last Name"
                                   class="p-inputtext p-component p-element w-full mb-3">

                            <label for="phone"
                                   class="block text-900 font-medium mb-2">Phone</label>
                            <p-inputMask mask="(999) 999-9999"
                                         formControlName="phone"
                                         name="phone"
                                         placeholder="Enter phone"
                                         required
                                         placeholder="(999) 999-9999"
                                         class="p-component p-element w-full mb-3"></p-inputMask>

                            <label for="email"
                                   class="block text-900 font-medium my-2">Email</label>
                            <input id="email"
                                   formControlName="email"
                                   name="email"
                                   required
                                   type="email"
                                   placeholder="Enter Your email"
                                   class="p-inputtext p-component p-element w-full mb-3">

                            <div *ngIf="editUserForm.controls.isFirebaseUser">
                                   <label for="isFirebaseUser"
                                          class="block text-900 font-medium mb-2"> Is Added to Firebase</label>
                                   <p-inputSwitch formControlName="isFirebaseUser"></p-inputSwitch>
                            </div>

                            <div *ngIf="!editUserForm.controls.isFirebaseUser">
                                   <label for="isAddFirebaseUser"
                                          class="block text-900 font-medium mb-2"> Add to Firebase</label>
                                   <p-inputSwitch formControlName="isFirebaseUser"></p-inputSwitch>
                            </div>
                            <label for="isActive"
                                   class="block text-900 font-medium mb-2"> Is Active</label>
                            <p-inputSwitch formControlName="isActive"></p-inputSwitch>

                     </div>
              </form>

              <ng-template pTemplate="footer">
                     <div class="flex justify-content-between">
                            <p-button class="btn btn-primary"
                                      (click)="onSaveUser()"
                                      [disabled]="!editUserForm.valid">Save</p-button>
                            <p-button class="btn btn-primary"
                                      (click)="onCancelUser()">Cancel</p-button>
                     </div>
              </ng-template>
       </p-card>
</div>